import type { StyleRule } from '@archipro-design/aria';
import { checkboxClassName } from '@archipro-design/aria';
import { labelClassName } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const ShippingOption: StyleRule = ({ theme, disabled }) => ({
    maxWidth: pxToRem(375),
    cursor: disabled ? 'not-allowed' : 'pointer',
    ':not(:last-child)': {
        marginBottom: theme.siteVariables.spaces['space-16'],
    },
    [theme.screen.tablet]: {
        maxWidth: 'unset',
    },
});

export const DisabledNote: StyleRule = ({ theme }) => ({
    lineHeight: pxToRem(24),
    fontSize: theme.siteVariables.fontSizes['caption03'],
    paddingLeft: theme.siteVariables.spaces['space-24'],
    color: theme.siteVariables.colors.grey['300'],
    fontStyle: 'italic',
});

export const Radio: StyleRule = ({ theme, disabled }) => ({
    ['&.' + checkboxClassName]: {
        ['& .' + labelClassName]: {
            ...theme.siteVariables.textStyles.Text.Medium65,
            color: disabled ? theme.siteVariables.colors.grey['300'] : theme.siteVariables.colors.charcoal['250'],
            marginLeft: theme.siteVariables.spaces['space-6'],
            lineHeight: pxToRem(26),
            fontSize: theme.siteVariables.fontSizes['label02'],
        },
        '& .ui-indicatorRadio': {
            width: pxToRem(16.67),
            height: pxToRem(16.67),
            marginLeft: pxToRem(2),
            borderWidth: '1.67px',
        },
    },
});

export const SubTitle: StyleRule = ({ theme, disabled }) => ({
    lineHeight: pxToRem(24),
    fontSize: theme.siteVariables.fontSizes['caption03'],
    paddingLeft: theme.siteVariables.spaces['space-24'],
    color: disabled ? theme.siteVariables.colors.grey['300'] : theme.siteVariables.colors.charcoal['250'],
});

export const ShippingCost: StyleRule = () => ({
    wordBreak: 'break-word',
});

export const ShippingThresholdMet: StyleRule = () => ({
    textDecoration: 'line-through',
});
